import styled from 'styled-components';
import { Link } from 'ui/links';
import { DOCS_URL } from './constants';
import { useTranslation } from '../hooks';

const INSIGHTS_DOC_LINK_DATA_TEST = 'aud-insights-doc-link';

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  flex-grow: 1;
`;

export const Toolbar = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Link
        hasOpenNewTabIcon
        href={DOCS_URL}
        target="_blank"
        data-test={INSIGHTS_DOC_LINK_DATA_TEST}
      >
        {t('insights.learnMore')}
      </Link>
    </Wrapper>
  );
};
